import React from 'react'
import { connect } from 'react-redux'
import { showModal } from '../../../redux/modules/modal'
import { selectUserInfo } from '../../../redux/modules/session'
import { toggleNavDropdown } from '../../../redux/modules/ui'
import SubjectToCSSName from '../../less/SubjectToCSSName'
import Footer from '../footer/Footer'
import {
  TertiaryButtonLight,
  BorderlessButtonLight,
  UniLink
} from '../unilink/index'
import {SUBJECT_TOPICS} from '../../../redux/modules/topic'
import LoggedInOptions from './LoggedInOptions'
import { SearchBox } from '../search-box/SearchBox'
import { withRouter } from 'react-router'
import './navbar.css'
import logo from './logoWhite.svg'
import MobileMenu from './MobileMenu'
import GridContainer from '../gridcontainer/GridContainer'
import Box from '../box/Box'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ic_x from '../../img/ic_x.svg'

// Normal Nav Bar
class NavBarComponent extends React.PureComponent {
  render() {
    const {
      showLogin,
      showRegister,
      searchEnabled,
      stateSearchEnabled,
      isLoggedIn,
      navbarSubject,
      dropdownIsToggled,
      toggleNavDropdown
    } = this.props
    const headerClassNames = ['navbar']
    if (navbarSubject) {
      headerClassNames.push(`navbar--${SubjectToCSSName[navbarSubject]}`)
    }
    const searchboxClassnames = searchEnabled || stateSearchEnabled ? ['navbar__search'] : ['navbar__search', 'navbar__search--inactive']
    return (
      <header className={headerClassNames.join(' ')}>
        <GridContainer>
          <div className="navbar__container">
            <div className='navbar__logo'>
              <UniLink to="/">
                <img src={logo} alt="Expii" />
              </UniLink>
              {
                isLoggedIn
                  ? <Box display='none' mdDisplay='inlineBlock' marginLeft={12}>
                    <UniLink to='/subjects' navLink activeStyle={{fontWeight: '600'}}>Subjects</UniLink>
                  </Box>
                  : null
              }
            </div>
            <UniLink
              className="navbar__logo navbar__logo--mobile"
              onClick={() => toggleNavDropdown(!dropdownIsToggled)}>
              <img src={logo} alt="Expii" />
              {
                dropdownIsToggled
                  ? <FontAwesomeIcon icon={['fa', 'angle-up']} className='navbar__dropdown-toggle-arrow' />
                  : <FontAwesomeIcon icon={['fa', 'angle-down']} className='navbar__dropdown-toggle-arrow' />
              }
            </UniLink>
            <MobileMenu />
            <SearchBox
              key='nav-search'
              className={searchboxClassnames.join(' ')}
              isEntryPoint
            />
            <nav className="navbar__navigation">
              {!isLoggedIn ? (
                <div className='navbar__logged-out-options'>
                  <BorderlessButtonLight
                    onClick={showLogin}
                    className="navbar__button"
                    style={{ marginRight: '.5em' }}
                  >
                  Log In{' '}
                  </BorderlessButtonLight>
                  <TertiaryButtonLight
                    onClick={showRegister}
                    className="navbar__button">
                    {' '}
                  Sign Up{' '}
                  </TertiaryButtonLight>
                </div>
              ) : (
                <LoggedInOptions />
              )}
            </nav>
          </div>
        </GridContainer>
      </header>
    )
  }
}
const mapStateToProps = state => {
  const userInfo = selectUserInfo(state)
  return {
    isLoggedIn: userInfo.isLoggedIn,
    stateSearchEnabled: state.getIn(['ui', 'navSearchEnabled']),
    dropdownIsToggled: state.getIn(['ui', 'dropdownIsToggled'])
  }
}
const mapDispatchToProps = dispatch => {
  return {
    toggleNavDropdown: (isOn) => dispatch(toggleNavDropdown(isOn)),
    showRegister: () => dispatch(showModal('REGISTER', {})),
    showLogin: () => dispatch(showModal('LOGIN', {}))
  }
}
export const NavBar = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(NavBarComponent))


// Nav bar for 'overlays' like search, grandmaster
export const ExitableNavBar = ({ goBack, embeddedComponents, navbarSubject }) => {
  const headerClassNames = ['navbar','navbar--exitable']
  if (navbarSubject) {
    headerClassNames.push(`navbar--${SubjectToCSSName[navbarSubject]}`)
  }
  const {CenterComponent, LeftComponent, RightComponent} = embeddedComponents
  return (
    <header className={headerClassNames.join(' ')}>
      <div className="navbar__container--exitable navbar__container gridcontainer">
        <nav className="navbar__navigation navbar__navigation--exitable">
          {
            LeftComponent
              ? <LeftComponent />
              : <UniLink onClick={() => goBack()} className="navbar__close">
                <img src={ ic_x } alt=""/>
              </UniLink>
          }
        </nav>
        {
          CenterComponent
            ? <CenterComponent />
            : null
        }
        {
          RightComponent
            ? <div className='navbar__right-component'>
              <RightComponent />
            </div>
            : null
        }
      </div>
    </header>
  )
}


export function withNav(Component, searchEnabled = false) {
  return ({ ...props }) => {
    let navbarSubject = false
    if (props.topic) {
      if (SUBJECT_TOPICS.has(props.topic.id)) {
        navbarSubject = props.topic.id
      } else if (props.topic.breadcrumbs && props.topic.breadcrumbs.length) {
        navbarSubject = props.topic.breadcrumbs[0].id
      }
    }
    return (
      <div className="with-nav">
        <NavBar navbarSubject={navbarSubject} searchEnabled={searchEnabled} />
        <Component {...props} className='component' />
        <Footer />
      </div>
    )
  }
}
export function withExitableNav(Component, defaultRoute = '/', embeddedComponents = {CenterComponent: null, LeftComponent: null}) {
  return props => {
    let goBack = props.history.goBack
    if (props.history.length <= 2) {
      goBack = () => props.history.push(defaultRoute)
    }
    let navbarSubject = props.topicId
    if (props.breadcrumbTopics && props.breadcrumbTopics.length) {
      navbarSubject = props.breadcrumbTopics[0].id
    }
    return (
      <div className="with-nav">
        <ExitableNavBar
          navbarSubject={navbarSubject}
          embeddedComponents={embeddedComponents}
          goBack={goBack} />
        <Component {...props} className='component' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/core/components/navbar/index.js